module.exports = __webpack_public_path__ + "img/anonymous-pro-dark.25e528b6.png";